export default __webpack_public_path__ + "static/media/notebook-winset.1596737f.png";